import axiosRetry from 'axios-retry';
import apiClient, { client as mainClient } from './client';
import { createFormdata } from './crudHelpers';
import queryString from "query-string";

const client = apiClient();

axiosRetry(client, { retries: 3 });

export function GET(url, config = {}) {
  return client.get(url,
    {
      ...config,
      paramsSerializer: (params) => {
        return queryString.stringify(params);
      }
    })
    .then(parseData)
    .catch(parseError)
}

export function POST(url, options = {}) {
  const { body, form, config = {} } = options;

  const parsedBody = form ? createFormdata(body) : body;

  return client.post(url, parsedBody, config)
  .then(parseData)
  .catch(parseError)
}


export function PUT(url, options = {}) {
  const { body, form, config = {} } = options;

  const parsedBody = form ? createFormdata(body) : body;

  return client({ url, data: parsedBody, ...config, method: 'PUT' })
    .then(parseData)
    .catch(parseError)
}

export function DELETE(url, options = {}) {
  const { body, form, config = {} } = options;

  const parsedBody = form ? createFormdata(body) : body;

  return client.delete(url, { data: parsedBody, ...config })
  .then(parseData)
  .catch(parseError)
}

async function parseData(response) {
  return response.data;
}

function parseError(err) {
  console.log(err)

  const response = err.response;

  const error = new Error('Something went wrong');

  if (response) {
    if (mainClient.isCancel(response)) {
      error.isCancelled = true;
      error.message = 'Request cancelled';
    } else {
      error.status =  response.status;
      error.message = response.error;
    }
  } else {
    error.status = 404;
  }

  throw error
}